import React from "react";
import PreviewItem from "../component.js/PreviewItem";
import { Link, useLocation } from "react-router-dom";
import { University } from "../component.js/data";
import moment from "moment";
import { ArrowLeft, ArrowLeft2 } from "iconsax-react";

const ApplicationDetails = () => {
  const loaction = useLocation();
  const state = loaction?.state;

  function formatDate(datetimeStr) {
    const date = moment(datetimeStr);
    const formattedDate = date.format("MMM DD, YYYY");
    return formattedDate;
  }
  return (
    <div className="p-4 md:p-8 lg:p-10">
      <div>
        <Link to="/myapplication" className="mb-3">
          <ArrowLeft />
        </Link>
      </div>

      <div className="border border-[#D6DDEB] p-[8px] md:p-[12px] rounded-lg grid grid-cols-2 items-start gap-x-5 gap-y-5">
        <PreviewItem title={"Award Type"} item={state?.Grant} />
        <PreviewItem title={"Education Level"} item={state?.Edu_Level} />
        <PreviewItem
          title={"Institution Name"}
          item={
            University &&
            University.map(
              (uni, index) =>
                state?.Institution === uni.value && (
                  <span key={index}>{uni.text}</span>
                )
            )
          }
        />
        <PreviewItem
          title={"Date Applied"}
          item={formatDate(state?.Date_Applied)}
        />

        <PreviewItem
          title={"Application Status"}
          item={state?.Application_Status}
        />
        <PreviewItem
          title={"Year of Admission"}
          item={state?.Year_of_Admission}
        />
        <PreviewItem title={"Course Of Study"} item={state?.Course} />
        <PreviewItem title={"Course Duration"} item={state?.Study_Duration} />
        <PreviewItem title={"Matric Number"} item={state?.Matric_No} />
        <PreviewItem
          title={"Current Class/Level"}
          item={state?.Current_Level}
        />
        <PreviewItem
          title={"Year of Graduation"}
          item={state?.Year_of_Completion}
        />
        <PreviewItem title={"Current CGPA Class"} item={state?.cgpa} />
        <PreviewItem title={"Current CGPA Value"} item={state?.Cgpa_value} />
        <PreviewItem title={"Lagos Division"} item={state?.Division} />
        <PreviewItem title={"Account Number"} item={state?.Bank_account} />
        <PreviewItem title={"Account Name"} item={state?.Account_name} />
        <PreviewItem title={"Bank Name"} item={state?.Bank_name} />
        <PreviewItem title={"Referee Name"} item={state?.Refree} />
        <PreviewItem title={"Referee Address"} item={state?.Refree_Address} />
        <PreviewItem title={"Referee Phone"} item={state?.Refree_Phone} />
      </div>
    </div>
  );
};

export default ApplicationDetails;
